import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type SubmissionState = {
  visible: boolean;
  message: string;
  stepKey?: string | null;
};

const initialState: SubmissionState = {
  visible: false,
  message: '',
  stepKey: null,
};

const submissionSlice = createSlice({
  name: 'submission',
  initialState,
  reducers: {
    // Muestra el loader con un mensaje
    showSubmission(state, action: PayloadAction<{ message: string; stepKey?: string }>) {
      state.visible = true;
      state.message = action.payload.message;
      state.stepKey = action.payload.stepKey ?? null;
    },
    // Actualiza el mensaje de progreso
    updateSubmission(state, action: PayloadAction<{ message: string; stepKey?: string }>) {
      state.message = action.payload.message;
      state.stepKey = action.payload.stepKey ?? state.stepKey ?? null;
    },
    // Oculta el loader y limpia estado
    hideSubmission() {
      return initialState;
    },
  },
});

export const { showSubmission, updateSubmission, hideSubmission } = submissionSlice.actions;
export default submissionSlice.reducer;
